import { createContext } from 'react';

export interface ChartTooltip {
  /** Show the bubble with pre-built HTML at viewport coords (SPEC §6.1). */
  show: (html: string, x: number, y: number) => void;
  hide: () => void;
}

export const TooltipContext = createContext<ChartTooltip | null>(null);
